exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".infobit{display:flex;align-items:baseline;flex:auto;position:relative;border-bottom:1px solid var(--grey-border)}.infobit:hover{background-color:var(--infobit-hover-color)}.infobit .icon{flex:none}.infobit .title{line-height:1.3em;margin-left:.2em}.infobit .button-panel{position:absolute;background-color:#fff;right:0;bottom:0;visibility:hidden}.infobit:hover .button-panel{visibility:visible}.infobit .button-panel button{color:var(--hotspot-color);border:1px solid var(--grey-border);width:2em;margin-top:2px;margin-bottom:2px;padding-top:2px;padding-bottom:3px}.infobit .button-panel button:enabled:hover{color:var(--hotspot-hover-color);cursor:pointer}.infobit.no-events{pointer-events:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-f0a6064c!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/infobit.vue
// module id = 96
// module chunks = 0